const LocaleMixin = {
  computed: {
    pathLocale () {
      return this.$route.params?.locale ? `/${this.$route.params.locale}` : ''
    }
  }
}

export default LocaleMixin
